module.exports = __webpack_public_path__ + "img/content.0a41b401.png";